import { SelectChangeEvent } from '@mui/material/Select/Select';
import { SelectField } from 'ui';
import { consumer } from '@tock/coretypes';
import { widgetTypeSelect } from 'components/consumer-page-widgets/widgetFormCssDefs';
import React, { FunctionComponent } from 'react';

export type AllNamedConfigTypeCases = NonNullable<
  consumer.NamedConfiguration['namedConfigurationConfig']
>;

export type WidgetTypeCases =
  | Exclude<
      NonNullable<consumer.NamedConfiguration['namedConfigurationConfig']>,
      'collectionPageConfig'
    >
  | 'carouselWidgetConfig';

export const widgetTypeToDisplayNameMapping: { [k in WidgetTypeCases]: string } = {
  cardLinkWidgetConfig: 'Featured Card widget',
  rowLayoutWidgetConfig: 'Row layout widget',
  avatarCardLinkWidgetConfig: 'Featured Card with Profile widget',
  shopHeroWidgetConfig: 'Shop hero widget',
  buttonArrayWidgetConfig: 'Button array widget',
  gridWidgetConfig: 'Grid widget',
  carouselWidgetConfig: 'Carousel widget',
  marketingFeaturesWidgetConfig: 'Masonry Grid widget',
  metroAreaWidgetConfig: 'Metro area container widget',
  offeringsPlatterWidgetConfig: 'Offering Platter widget',
};

interface WidgetTypeSelectProps {
  selectedWidgetType: WidgetTypeCases;
  onChangeType(type: WidgetTypeCases): void;
}

export const WidgetTypeSelect: FunctionComponent<
  React.PropsWithChildren<WidgetTypeSelectProps>
> = ({ selectedWidgetType, onChangeType }) => {
  const handleChangeWidgetType = (
    event: SelectChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>
  ) => onChangeType(event.target.value as WidgetTypeCases);

  return (
    <SelectField
      label="Widget type"
      value={selectedWidgetType}
      onChange={handleChangeWidgetType}
      css={widgetTypeSelect}
    >
      {Object.entries(widgetTypeToDisplayNameMapping).map(([key, value]) => {
        return <option key={key} value={key} label={value} />;
      })}
    </SelectField>
  );
};
